import actionTypes from './actionTypes'

const whiteboardActions = {
	mounted: (sessionId, slideId, role, jwt) => (
		{
			type: actionTypes.WHITEBOARD_MOUNTED,
			sessionId,
			slideId,
			role,
			jwt,
		}
	),
	updated: (sessionId, slideId, role, jwt) => (
		{
			type: actionTypes.WHITEBOARD_UPDATED,
			sessionId,
			slideId,
			role,
			jwt,
		}
	),
	unmounted: () => (
		{
			type: actionTypes.WHITEBOARD_UNMOUNTED,
		}
	),
	actionsChanged: actions => (
		{
			type: actionTypes.WHITEBOARD_ACTIONS_CHANGED,
			actions,
		}
	),
	actionsReceived: actions => (
		{
			type: actionTypes.WHITEBOARD_ACTIONS_RECEIVED,
			actions,
		}
	),
	whiteboardFetched: whiteboard => (
		{
			type: actionTypes.WHITEBOARD_FETCHED,
			whiteboard,
		}
	),
	initializationFailed: error => (
		{
			type: actionTypes.WHITEBOARD_INITIALIZATION_FAILED,
			error,
		}
	),
	enable: mode => ({
		type: actionTypes.WHITEBOARD_ENABLE,
		mode,
	}),

	disable: () => ({
		type: actionTypes.WHITEBOARD_DISABLE,
	}),
	enabled: data => ({
		type: actionTypes.WHITEBOARD_ENABLED,
		data,
	}),

	disabled: () => ({
		type: actionTypes.WHITEBOARD_DISABLED,
	}),

	toggleBackground: () => ({
		type: actionTypes.WHITEBOARD_TOGGLE_BACKGROUND,
	}),

	setBackground: value => ({
		type: actionTypes.WHITEBOARD_SET_BACKGROUND,
		value,
	}),

	drawingFetched: data => ({
		type: actionTypes.WHITEBOARD_DRAWING_FETCHED,
		data,
	}),

	disconnected: data => ({
		type: actionTypes.WHITEBOARD_DISCONNECTED,
		data,
	}),
}

export default whiteboardActions
